import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaterialTable from '@material-table/core';
import { useHistory } from 'react-router-dom';
import localization from "../../localisation.json";

function PlacePage() {
  let history = useHistory();
  let { id } = useParams();

  const [data, setData] = useState({name: "", additional_info: "-", occs: [], places: [], pubs: []});

  useEffect(() => {
    function fetchPageData() {
      fetch("http://medpub-backend-dmpn.ext.ocp-prod-0.k8s.it.helsinki.fi/place/" + id)
      .then(res => res.json())
      .then(result => setData(result))
      .catch(console.log);
    }
    fetchPageData();
  }, [id]);

  return (
    <div className="home">
      <div class="entity-page-container">
        <div class="page-header">
          <img src="register-location.png" alt="" />
          <h1>{data.name}</h1>
        </div>
        <div class="row entity-page-content justify-content-start">
          <div class="col-lg-2">
            <p>
              Place ID: {id}
            </p>
          </div>
          <div class="col-lg-10">
            <p>
              <h4>Persons connected:</h4>
            </p>
            <p>
              <MaterialTable
                columns={[
                  { title: 'ID', field: "id"},
                  { title: 'Name', field: "name" }
                ]}
                data={data.persons}
                options={{
                  toolbar: false,
                  header: true,
                  columnsButton: false,
                  exportButton: false,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#1b437e',
                    color: '#FFF'
                  },
                }}
                localization={localization}
                onRowClick={((evt, selectedRow) => {
                  history.push('/person/' + selectedRow.id)
                })}
              />
            </p>
            <p>
              <h4>Publication data:</h4>
            </p>
            <p>
            <MaterialTable
                columns={[
                  { title: 'pub_id', field: "id"},
                  { title: 'work_id', field: "work_id" },
                  { title: 'Title', field: "title" },
                  { title: 'Authorial status', field: "authorial_status" },
                ]}
                data={data.pubs}
                options={{
                  toolbar: false,
                  header: true,
                  columnsButton: false,
                  exportButton: false,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#1b437e',
                    color: '#FFF'
                  },
                }}
                localization={localization}
                onRowClick={((evt, selectedRow) => {
                  history.push('/work/' + selectedRow.work_id)
                })}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlacePage;